export default __webpack_public_path__ + "static/media/pngaaa.com-2507897.25b94b00.png";